interface ErrorDetails {
    slot?: string
    [key: string]: any
}

interface ErrorMessage {
    code?: string
    message?: string
    error?: string
    detales?: ErrorDetails
    [key: string]: any
}

interface ApiError {
    message?: string | ErrorMessage
    statusText?: string
    lockedBy?: string
    code?: string
    details?: any
    [key: string]: any
}

interface DialogNotifyOptions {
    position: string
    timeout: number
}

interface ErrorHandlerContext {
    _i18n: {
        messages: Record<string, Record<string, string>>
        locale: string
    }
    $dialog: {
        notify: {
            error: (message: string, options: DialogNotifyOptions) => void
        }
    }
}

/**
 * Обработчик ошибок для отображения понятных сообщений пользователю
 * @param err - Объект ошибки
 * @param name - Тип/источник ошибки (DabLock, runProcess, wmi и т.д.)
 * @this ErrorHandlerContext - Контекст Vue компонента
 */
export default function(this: ErrorHandlerContext, err: ApiError, name?: string): void {
    console.log('ERROR_HANDLER', err)

    const $getTranslate = (str: string): string => {
        const translation = this._i18n.messages[this._i18n.locale]?.[str]
        return translation || str
    }

    // Обработка DabLock ошибок
    if (name && name === 'DabLock') {
        console.error('DabLock', 'error', err)
        const message = err.lockedBy 
            ? `${$getTranslate('editing blocked by')} ${err.lockedBy}` 
            : $getTranslate('editing blocked')
        this.$dialog.notify.error(message, {
            position: 'top-right',
            timeout: 3000
        })
        return
    }

    // Обработка runProcess ошибок
    if (name && name === 'runProcess') {
        const er = JSON.parse(JSON.stringify(err)) as ApiError
        const code = er.code ? this.$getTranslate(er.code) : this.$getTranslate('error')
        const details = er.details && Object.keys(er.details).length ? er.details : null
        console.error('SHOW_DEVICE_BAR', 'runProcess', 'error', er)
        const message = details ? `${code} ${JSON.stringify(details)}` : code
        this.$dialog.notify.error(message, {
            position: 'top-right',
            timeout: 3000
        })
        return
    }

    // Обработка WMI ошибок
    if (name && name === 'wmi') {
        const code = this.$getTranslate('missing parameter')
        const details = err as unknown as string
        const message = details ? `${code} ${details}` : code
        this.$dialog.notify.error(message, {
            position: 'top-right',
            timeout: 3000
        })
        return
    }

    // Обработка ошибок с полем message
    if (err.message) {
        // Обработка SLOT_IS_BUSY
        if (typeof err.message === 'object' && err.message.code === 'SLOT_IS_BUSY') {
            const name$ = $getTranslate('slot')
            const body$ = $getTranslate('is busy')
            const slot = (err.message.detales?.slot) || ''
            const message = `${name$} ${slot} ${body$}`
            console.error('ERROR_HANDLER SLOT_IS_BUSY', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка "already exist on this level"
        if (typeof err.message === 'object' && err.message.message?.includes('already exist on this level')) {
            const error = err.message.message
            console.log('handler name', error.split(' '))
            const start$ = $getTranslate('name')
            const body$ = $getTranslate('already exist on this level')

            let text = error.replace("already exist on this level", "");
            const name = text.replace("name", "");
            console.log('new name', name)

            const message = `${start$} ${name} ${body$}`
            // const message = `${start$} ${error.split(' ')[1]} ${body$}`
            console.error('ERROR_HANDLER already exist', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка err.message.code и err.message.message
        if (typeof err.message === 'object' && err.message.code && err.message.message) {
            const message = $getTranslate(err.message.message)
            console.error('ERROR_HANDLER err.message.message', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка err.message.code и err.message.message
        if (typeof err.message === 'object' && err.message.error) {
            const message = $getTranslate(err.message.error)
            console.error('ERROR_HANDLER err.message.error', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка string message
        if (typeof err.message === 'string' && err.statusText) {
            const message = $getTranslate(err.message)
            console.error('ERROR_HANDLER err.message.error', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка statusText
        if (err.statusText) {
            const message = $getTranslate(err.statusText)
            console.error('ERROR_HANDLER err.statusText', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }

        // Обработка err.message.error
        if (typeof err.message === 'object' && err.message.error) {
            const message = $getTranslate(err.message.error)
            console.error('ERROR_HANDLER err.message.error', message)
            this.$dialog.notify.error(message, {
                position: 'top-right',
                timeout: 3000
            })
            return
        }
    }

    // Обработка неизвестных ошибок
    const message = $getTranslate('something wrong on server')
    console.log('ERROR_HANDLER NOTIFY', this.$dialog)
    
    if (this.$dialog.notify) {
        this.$dialog.notify.error(message, {
            position: 'top-right',
            timeout: 3000
        })
    } else {
        alert(message)
    }
}